module.exports = __webpack_public_path__ + "img/rod-2.b9975e03.png";